module.exports = "/static-assets/_next/static/images/frog-dollar-sign-766216fb4950310c6785dea76bcac372.png";